import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';
import {useQueryClient} from '@tanstack/react-query';
import {productFeaturesQueryKeys} from '../hooks/useProductFeatures.ts';

export const ReloadRecordsButton = () => {
    const queryClient = useQueryClient();

    const handleReload = () => {
        queryClient.invalidateQueries({queryKey: productFeaturesQueryKeys.all});
    };

    return (
        <Box mx='sm'>
            <ReloadButton onClick={handleReload}/>
        </Box>
    );
};
